"use client";

import { ChangeLanguage } from "@/components/shared";
import { MainLink, MenuLink, NavigationMenu } from "@/components/shared/public";
import { Separator } from "@/components/ui/separator";
import { Link } from "@/i18n/navigation";
import { useTranslations } from "next-intl";
import Image from "next/image";
import { useEffect, useState } from "react";
import { mainLogo } from "../../../public/images/logos";
import PublicNotificationBanner from "./PublicNotificationBanner";
import Sidebar from "./sidebar/Sidebar";

// Darkness-weighted logo centroid sits 5.6px below the raster center at 50px rendered height.
const LOGO_PERCEPTUAL_Y_OFFSET = "-5.6px";

const Navbar = () => {
  const t = useTranslations("common");

  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 0);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <div
        className={`fixed top-0 z-50 w-full bg-white ${
          "border-b transition-colors duration-300" +
          (scrolled ? " border-b-border" : " border-b-transparent")
        }`}
      >
        <div className="mx-auto grid h-16 w-full max-w-screen-xl grid-cols-[1fr_auto] items-center px-4 py-2 sm:px-6 lg:h-[72px] lg:grid-cols-[1fr_auto_1fr] lg:px-8">
          <Link
            href={"/"}
            className="flex h-[50px] items-center justify-self-start"
          >
            <Image
              src={mainLogo}
              width={180}
              height={50}
              alt={t("imageAlt.mainLogo")}
              priority
              className="block h-[50px] w-[180px] cursor-pointer"
              style={{ transform: `translateY(${LOGO_PERCEPTUAL_Y_OFFSET})` }}
            />
          </Link>
          <div className="hidden items-center gap-6 justify-self-center lg:flex xl:gap-10">
            <NavigationMenu
              trigger={t("floorPlans")}
              content={
                <>
                  <MenuLink
                    href={"/grundriss-designs"}
                    title={t("floorPlanDesigns")}
                  />
                  <Separator />
                  <MenuLink
                    href={"/verkaufsoptimierte-grundrisse"}
                    title={t("salesOptimizedFloorPlans")}
                  />
                  <Separator />
                  <MenuLink
                    href={"/bemasste-grundrisse"}
                    title={t("sizedFloorPlans")}
                  />
                  <Separator />
                  <MenuLink
                    href={"/aufmass-service-vor-ort"}
                    title={t("measuringService")}
                  />
                  <Separator />
                  <MenuLink
                    href={"/individuelle-grundrisse"}
                    title={t("individual")}
                  />
                </>
              }
              href={""}
              linkTitle={""}
            />
            <NavigationMenu
              trigger={t("threeSixtyTour")}
              content={
                <>
                  <MenuLink
                    href={"/360-grad-rundgang"}
                    title={t("threeSixtyTour")}
                  />
                  <Separator />
                  <MenuLink
                    href={"/360-grad-matterport-service"}
                    title={t("threeSixtyTourService")}
                  />
                </>
              }
              href={""}
              linkTitle={""}
            />
            <NavigationMenu
              trigger={t("about")}
              content={
                <>
                  <MenuLink href={"/preise"} title={t("prices")} />
                  <Separator />
                  <MenuLink href={"/team"} title={"Team"} />
                  <Separator />
                  <MenuLink href={"/stellenangebote"} title={t("jobAds")} />
                  <Separator />
                  <MenuLink href={"/partner"} title={t("footerInfo.partner")} />
                  <Separator />
                  <MenuLink
                    href={"/soziales-engagement"}
                    title={t("footerInfo.socialEngagement")}
                  />
                  <Separator />
                  <MenuLink href={"/blog"} title={t("blog")} />
                </>
              }
              href={""}
              linkTitle={""}
            />
            <NavigationMenu
              trigger={""}
              content={""}
              href="/faq"
              linkTitle="FAQ"
            />
          </div>
          <div className="hidden shrink-0 items-center gap-3 justify-self-end lg:flex xl:gap-4">
            <MainLink
              href={"/login"}
              title={t("customerPortal")}
              className="shrink-0 lg:px-4 xl:px-6"
            />
            <div className="shrink-0">
              <ChangeLanguage />
            </div>
          </div>

          <div className="flex items-center lg:hidden">
            <Sidebar />
          </div>
        </div>
      </div>
      <PublicNotificationBanner />
    </>
  );
};

export default Navbar;
